/**
 * global variables
 */

const apiBaseURL = "https://api.cash-mobile.legrandsoft.com/api"; // "http://localhost:5001/api";

const routes = [
    {
        path: "/",
        name: "accueil",
        label: "Accueil",
        inMenu: true,
        access: 1
    },
    {
        path: "/transactions",
        name: "transactions",
        label: "Transactions",
        inMenu: true,
        access: 1
    },
    {
        path: "/approvisionnements",
        name: "approvisionnements",
        label: "Approvisionnements",
        inMenu: true,
        access: 20
    },
    {
        path: "/recharges",
        name: "recharges",
        label: "Recharges",
        inMenu: true,
        access: 40
    },
    {
        path: "/clients",
        name: "clients",
        label: "Clients",
        inMenu: true,
        access: 10
    },
    {
        path: "/utilisateurs",
        name: "utilisateurs",
        label: "Utilisateurs",
        inMenu: true,
        access: 40
    },
    {
        path: "/partenaires",
        name: "partenaires",
        label: "Partenaires",
        inMenu: true,
        access: 40
    },
    {
        path: "/finances",
        name: "finances",
        label: "Etat financier",
        inMenu: true,
        access: 7
    }
];

const modesPaiementMobile = [
    { name: "Orange Cameroun", operateur: "ORANGE", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: true, hasMomo: true, hasBill: false },
    { name: "MTN Cameroun", operateur: "MTN", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: true, hasMomo: true, hasBill: false },
    { name: "Express Union Mobile", operateur: "EU", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "YUP Cameroun", operateur: "YUP", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "NEXTTEL Cameroun", operateur: "NEXTELL", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: true, hasMomo: false, hasBill: false },
    { name: "YOOMEE Cameroun", operateur: "YOOMEE", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: true, hasMomo: false, hasBill: false },
    { name: "Facture ENEO", operateur: "ENEO", devise: "XAF", pays: "CM", paysLabel: "Cameroun", hasAirtime: false, hasMomo: false, hasBill: true },
    { name: "Orange Côte d'Ivoire", operateur: "OM-CI", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: true, hasMomo: true, hasBill: false },
    { name: "MTN Côte d'Ivoire", operateur: "MTN-CI", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: true, hasMomo: true, hasBill: false },
    { name: "MOOV", operateur: "MOOV", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "YUP Côte d'Ivoire", operateur: "YUP-CI", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "ADVANS Côte d'Ivoire", operateur: "ADVANS", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "WIZALL", operateur: "WIZALL-WALLET", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: true, hasBill: false },
    { name: "CIE", operateur: "CIE", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: false, hasBill: true },
    { name: "SODECI", operateur: "SODECI", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: false, hasMomo: false, hasBill: true },
    /*
    { name: "Orange Guinée", operateur: "OM_GUINEE", devise: "GNF", pays: "GN" },
    { name: "MTN Guinée", operateur: "MTN_GUINEE", devise: "GNF", pays: "GN" },
    { name: "TIGO", operateur: "TIGO", devise: "XOF", pays: "CI", paysLabel: "Côte d'Ivoire", hasAirtime: true, hasMomo: true, hasBill: false },
    { name: "MALITEL MobiCash", operateur: "MALITEL", devise: "XOF", pays: "MA" },
    { name: "AIRTEL", operateur: "AIRTEL", devise: "KES", pays: "KN" },
    { name: "SAFARICOM", operateur: "SAFARICOM", devise: "KES", pays: "KN" }*/
];

const pays = [
    {name: "Allemagne", devise: "EUR", iso: "AL", code: 49},
    {name: "Belgique", devise: "EUR", iso: "BE", code: 32},
    {name: "Cameroun", devise: "XAF", iso: "CM", code: 237},
    {name: "Canada", devise: "CAD", iso: "CA", code: 1},
    {name: "Chine", devise: "RMB", iso: "CN", code: 86},
    {name: "Côte d'Ivoire", devise: "XOF", iso: "CI", code: 225},
    {name: "Espagne", devise: "EUR", iso: "ES", code: 34},
    {name: "Etats Unis d'Amérique", devise: "USD", iso: "US", code: 1},
    {name: "France", devise: "EUR", iso: "FR", code: 33},
    {name: "Guinnée", devise: "XOF", iso: "GN", code: 224},
    {name: "Italie", devise: "EUR", iso: "IT", code: 39},
    {name: "Royaume Uni", devise: "GBP", iso: "GB", code: 44}
];

const droitsAcces = [
    {name: "Niveau 0 (Client)", type: 0},
    {name: "Niveau 1 (Guichet partenaire)", type: 1},
    {name: "Niveau 6 (Superviseur partenaire)", type: 6},
    {name: "Niveau 8 (Administrateur partenaire)", type: 8},
    {name: "Niveau 9 (Super administrateur partenaire)", type: 9},
    {name: "Niveau 10 (Superviseur local)", type: 10},
    {name: "Niveau 20 (Administrateur local)", type: 20},
    {name: "Niveau 30 (Superviseur)", type: 30},
    {name: "Niveau 40 (Administrateur)", type: 40},
    {name: "Niveau 50 (Super administrateur)", type: 50},
];

export {
    modesPaiementMobile, 
    routes,
    apiBaseURL,
    pays,
    droitsAcces
};